import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.sass';
import cx from 'classnames';

class TableRow extends PureComponent {
  render() {
    const {children, className: clName, style: stl, onClick} = this.props;
    return (<div onClick={onClick} style={stl} className={cx(styles.tableRow, clName)}>{children}</div>)
  }
}

TableRow.defaultProps = {};

TableRow.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.any,
  onClick: PropTypes.func
};

export default TableRow;


// WEBPACK FOOTER //
// ./src/components/common/Table/TableRow.jsx